import React from 'react';
import TrackingContext from './TrackingContext';

import useAmplitudeClient from '../../libs/amplitude/useAmplitudeClient';
import AmplitudeProvider from '../../libs/amplitude/AmplitudeProvider';

import AmplitudeAdapter from './AmplitudeAdapter';
import GoogleAnalyticsAdapter from './GoogleAnalyticsAdapter';
import LoggerAdapter from './LoggerAdapter';
import AggregatorTrackingAdapter from './AggregatorTrackingAdapter';

function TrackingProviderInternal({ children }) {
  const amplitude = useAmplitudeClient();

  const trackingHandler = new AggregatorTrackingAdapter([
    new AmplitudeAdapter(amplitude),
    new GoogleAnalyticsAdapter(),
    new LoggerAdapter()
  ]);

  return <TrackingContext.Provider value={trackingHandler}>{children}</TrackingContext.Provider>;
}

export default function TrackingProvider({ children }) {
  return (
    <AmplitudeProvider>
      <TrackingProviderInternal>{children}</TrackingProviderInternal>
    </AmplitudeProvider>
  );
}
